var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"font-weight-regular text--disabled"},[_c('span',{staticClass:"red--text text--lighten-1"},[_vm._v("*")]),_vm._v(" "+_vm._s(_vm.$t('common.requiredFields'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }